<template>
  <div class="">
    <b-card
      class="page-card"
      headerClass="page-card-header"
      bodyClass="page-card-body"
    >
      <div slot="header" v-if="showHeader">
        <b-row>
          <b-col cols="12">
            <div class="page-header-left">
              <div class="pr-1 header-icon">
                <CIcon
                  :content="cilMemory"
                  class="c-icon-custom-size"
                  v-if="isCIcon"
                />
                <i :class="cardIcon" v-else></i>
              </div>
              <div>
                <h5 class="mb-0">
                  <b>{{ pageName }}</b>
                  <span v-if="pageType">
                    - <i>{{ pageType }}</i></span
                  >
                </h5>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <slot name="page_content"></slot>
    </b-card>
  </div>
</template>

<script>
import { CIcon } from '@coreui/icons-vue'
import { cilMemory } from '@coreui/icons'
export default {
  name: 'LayoutPageCard',
  props: {
    pageName: {
      type: String,
      required: true,
      default: '-'
    },
    pageType: {
      type: String,
      required: false
    },
    iconClass: {
      type: Array,
      required: false
    },
    showHeader: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: { CIcon },
  data() {
    return {
      linkActive: true,
      cilMemory
    }
  },
  computed: {
    cardIcon() {
      return this.iconClass ? this.iconClass : ['fa', 'fa-bar-chart', 'fa-lg']
    },
    //TODO: Need to generalize based on future need
    isCIcon() {
      return this.cardIcon.some(icon => icon === 'cilMemory')
    }
  }
}
</script>

<style lang="scss" scoped>
.c-icon-custom-size {
  width: 25px;
  height: 25px;
}
</style>
